import { useState as r } from "react";
import { useUpdateContactInformation as A } from "../../api/repositories/customers/useUpdateContactInformation.js";
import { usePhoneVerificationRequest as b, PhoneVerificationRequestError as y } from "../../api/repositories/customers/usePhoneVerificationRequest.js";
import { usePhoneVerificationConfirm as D, PhoneVerificationConfirmError as K } from "../../api/repositories/customers/usePhoneVerificationConfirm.js";
import { useAuth as U } from "./useAuth.js";
function W({ onSaved: c } = {}) {
  const {
    customer: a,
    token: t,
    scope: u
  } = U(), { mutateAsync: C } = A(), P = b(), I = D(), [E, n] = r(!1), [q, p] = r(), [F, i] = r(!1), [R, h] = r(!1), [v, l] = r(void 0), [d, w] = r(null), [M, V] = r(30), [f, S] = r(""), s = a !== null && t !== null, g = async (o, e) => {
    if (a === null || t === null)
      throw new Error("Customer wasn't loaded");
    const m = a.profile.clone();
    m.phone = o, await C({
      profile: m,
      token: t,
      scope: u,
      phoneVerificationToken: e
    });
  }, x = {
    "otp-request-cooldown": "phoneInputForm.error.otpRequestCooldown",
    "otp-rate-limit": "phoneInputForm.error.otpRateLimit",
    "sms-provider-error": "phoneInputForm.error.smsProviderError"
  };
  return {
    canStartFlow: s,
    submitPhone: async (o) => {
      if (s) {
        S(o), p(void 0);
        try {
          const e = await P.mutateAsync({ token: t, phone: o, scope: u });
          w(e.otpRequestId), V(e.cooldownSeconds), l(void 0), n(!1), i(!0);
        } catch (e) {
          console.error(e), e instanceof y && (e.errorCode === "phone-already-in-use" ? (n(!1), h(!0)) : p(
            x[e.errorCode] ?? "phoneVerification.error.generic"
          ));
        }
      }
    },
    showPhoneInputForm: E,
    openPhoneInputForm: () => {
      p(void 0), n(!0);
    },
    closePhoneInputForm: () => {
      n(!1);
    },
    phoneInputErrorMessage: q,
    showPhoneVerification: F,
    hidePhoneVerification: () => {
      i(!1);
    },
    handlePhoneVerificationSubmit: async (o) => {
      if (!(d === null || !s)) {
        l(void 0);
        try {
          await I.mutateAsync({
            token: t,
            otpRequestId: d,
            otpCode: o
          });
        } catch (e) {
          console.error(e), e instanceof K && (e.errorCode === "phone-already-in-use" ? (i(!1), h(!0)) : l({
            "otp-invalid-code": "phoneVerification.error.invalidCode",
            "otp-expired": "phoneVerification.error.expired",
            "otp-already-used": "phoneVerification.error.alreadyUsed",
            "otp-attempts-exceeded": "phoneVerification.error.attemptsExceeded"
          }[e.errorCode] ?? "phoneVerification.error.generic"));
          return;
        }
        i(!1);
        try {
          await g(f, d ?? void 0), await (c == null ? void 0 : c());
        } catch (e) {
          console.error(e);
        }
      }
    },
    handlePhoneVerificationResend: async () => {
      if (s)
        try {
          const o = await P.mutateAsync({
            token: t,
            phone: f,
            scope: u
          });
          w(o.otpRequestId), V(o.cooldownSeconds);
        } catch (o) {
          if (o instanceof y && o.errorCode === "otp-request-cooldown")
            return;
          console.error(o);
        }
    },
    cooldownSeconds: M,
    showDuplicatePhoneError: R,
    hideDuplicatePhoneError: () => {
      h(!1);
    },
    currentPhone: f,
    errorMessage: v
  };
}
export {
  W as usePhoneValidationFlow
};
//# sourceMappingURL=usePhoneValidationFlow.js.map
